import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next"; // Required to manually sync language

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const DaysComponent = ({ days }) => {
  const { t } = useTranslation();
  const locale = getLocaleFromCookie();

  // Sync i18n language with cookie locale
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }

  if (!Array.isArray(days) || days.length === 0) return null;

  const getTimeText = (timeBlocks) => {
    if (!Array.isArray(timeBlocks) || timeBlocks.length === 0) return "-";
    return timeBlocks
      .map((block) =>
        block?.children?.map((child) => child.text).join(" ") || "-"
      )
      .join("\n");
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-1 text-black">{t("events.openingTime", "Opening Time")}</h2>
      <ol className="list-group list-group-separated col-12">
        {days.map((dayItem) => (
          <li
            key={dayItem.id}
            className="list-group-item d-flex justify-content-between align-items-start text-black"
          >
            <span>
              <p
                className="lead mt-0 mb-0"
                style={{ lineHeight: "90%", textTransform: "uppercase" }}
              >
                {dayItem.day || "-"}
              </p>
            </span>
            <p
              className="lead mt-0 mb-0 text-end"
              style={{
                lineHeight: "90%",
                textTransform: "uppercase",
                whiteSpace: "pre-line", // keeps \n line breaks
              }}
            >
              {getTimeText(dayItem.time)}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default DaysComponent;
